export const isBlank = (str: string | null) => {
  return !!!str || /^\s*$/.test(str);
};
